import {REHYDRATE} from 'redux-persist';

import {unexpectedCase} from 'nutshell-core/reducer-utils';

import type {McfxViqContactFragment as Contact} from 'nutshell-graphql-types';

import {ActionTypes} from './actions';
import type {SidebarAction} from './actions';

export type PeopleIqState = {
    accountId: string | null | undefined;
    accountName: string | null | undefined;
    leadId: string | null | undefined;
    contacts: Contact[];
    dismissedAccounts: string[];
};

export const defaultPeopleIqState = {
    accountId: undefined,
    accountName: undefined,
    leadId: undefined,
    contacts: [],
    dismissedAccounts: [],
} as const;

export const peopleIqReducer = (
    // @ts-expect-error
    state: PeopleIqState | null | undefined = defaultPeopleIqState,
    action: SidebarAction
): PeopleIqState => {
    switch (action.type) {
        case ActionTypes.SIDEBAR_OPENED:
            // @ts-expect-error
            return {
                ...state,
                ...action.payload,
            };
        case ActionTypes.SIDEBAR_CLOSED:
            // @ts-expect-error
            return defaultPeopleIqState;
        case ActionTypes.DISMISS_FOR_ACCOUNT:
            // @ts-expect-error
            return {
                ...state,
                // @ts-expect-error
                dismissedAccounts: [...state.dismissedAccounts, action.payload.accountId],
            };
        // @ts-expect-error
        case REHYDRATE: {
            // @ts-expect-error
            const persistedState = action.payload;
            if (!persistedState || !persistedState.ui || !persistedState.ui.peopleIq) {
                // @ts-expect-error
                return state;
            }

            return persistedState.ui.peopleIq;
        }
        default:
            // @ts-expect-error
            unexpectedCase(action.type);

            // @ts-expect-error
            return state;
    }
};
